import VulnerCollapseCard from './vulner_collapse_card'
export default VulnerCollapseCard